<template>
    <div class="manuAssign">
      <template>
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <ots-table-group-new
          :messageDescript="messageDescript"
          :selectList="selectList"
          :requestForm="requestForm"
          @search="searchList"
          :tableHeader="tableHeader"
          :tableData="tableData"
          :pagination="pagination"
          @changeNum="changeNum"
          @changePage="changePage"
        >
        </ots-table-group-new>
      </template>
    </div>
</template>

<script>
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import { getReTeacher, selectTeacherReview, importTeacherReviewListSet } from "@/http/modules/markPaper";

export default {
  data() {
    return {
      messageDescript: "此功能仅用于统计评阅教师工作量，不显示自动评阅数据",

      // 标题按钮
      mainTopBtnList: [
        {
          title: '导出',
          fn: this.exportReview
        }
      ],
      // 查询表单
      selectList : [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: []
        },
        {
          title: "课程",
          type: "select",
          requestKey: "courseId",
          label: "name",
          value: "id",
          data: []
        },
        {
          title: "评阅教师",
          type: "select",
          label: "teacherName",
          value: "teacherId",
          requestKey: "teacherId",
          data: []
        },
      ],
      /* ** 请求参数 ** */
      requestForm: {
        planId: "",
        courseId: "",
        teacherId: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "评阅教师",
          prop: "teacherName",
        },
        {
          title: "教师用户名",
          prop: "userName",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "课程",
          prop: "courseName",
        },
        {
          title: "试卷",
          prop: "paperperNames",
        },
        {
          title: "已分配人数",
          prop: "assNumber"
        },
        {
          title: "已考人数",
          prop: "examNum",
        },
        {
          title: "已评阅人数",
          prop: "aReviewNum"
        },
        {
          title: "待评阅人数",
          prop: "waitReviewNum"
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
    }
  },
  watch: {
    "requestForm.planId" (val) {
      this.getThisPlanCourse(val);
    },
    "requestForm.courseId" (val) {
      this.getThisPlanTeacher(val);
    }
  },
  mounted(){
    this.initData();
  },
  methods: {
    /***********************************
     * @initData 初始化表单数据
     ***********************************/
    initData() {
      this.mixin_getSelectPlan().then( data => {2
        this.selectList[0].data = data;
        this.requestForm.planId = data[0].id;
      });
    },

    /***********************************
     * @this 根据批次查询课程,场次
     ***********************************/
    getThisPlanCourse(planId){
      getPlanCourseFn({planId: planId}).then( res => {
        let courseData = res.data.map( e => { return {id: e.courseId, name: e.courseName} });
        this.selectList[1].data = courseData;
        this.requestForm.courseId = courseData[0].id;
        this.search();
      })
    },

    /***********************************
     * @this 根据课程查询评阅教师
     ***********************************/
    getThisPlanTeacher(courseId) {
      let params = {
        planId: this.requestForm.planId,
        courseId: courseId
      };
      getReTeacher(params).then(res=>{
        this.selectList[2].data = [
          {teacherId: "", teacherName: "全部"},
          ...res.data
        ];
        this.requestForm.teacherId = "";
      });
    },

    // 导出
    exportReview() {
      let params = {
        courseId: this.requestForm.courseId,
        planId: this.requestForm.planId,
        teacherId: this.requestForm.teacherId
      }
      importTeacherReviewListSet(params).then(res=>{
        if (res.code == 1) {
          window.location.href = res.data;
        }
      })
    },

    // 搜索按钮
    searchList(){
      this.requestForm.size = 10;
      this.requestForm.page = 1;
      this.search();
    },
    
    // 查询表格数据
    search(){
      let params = { ...this.requestForm };
      selectTeacherReview(params).then( res => {
        this.pagination.total = res.data.total;
        this.tableData = res.data.records;
      })
    },

    /***********************
     * @this 分页-每页数量
     **********************/
    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    /***********************
     * @this 分页-页码
     **********************/
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  }
}
</script>

<style lang="less" scoped>

</style>